import ViewBase from '../../views/view-base.view';
import { messageComponent } from '../message/message.component';
import userSearchModal from '../../models/common/user-search.modal';
import paginationComponent from '../pagination/pagination.component';
import loginModel from '../../models/login.model';
import languageModel from '../../models/language.model';

/**
 * @deprecated
 */
export default function UserAttributeListComponent() {
  ViewBase.call(this);

  let onSave = (e, id) => { };
  let onAddClose = (e) => { };

  let country;
  let type = "";
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let inputDatModel = { totalCount: 0, pageIndex: 1, pageSize: 10, masterId: 0, user: "", userAttributeList: [], attributeOptionsList: [], userRoleList: [], userList: [], selectedUserRoles: [] };
  let selectedAttribute = [];
  let selectedInputAttribute = [];
  let needSearchBar = false;
  let hightClass = "";
  let needPagination = false;

  let _getName = (e) => {
    inputDatModel.user = e.target.value;
  }

  let _save = (e) => {
    onSave(selectedAttribute, inputDatModel.masterId);
  }

  let _cancel = (e) => {
    selectedAttribute = selectedInputAttribute;
    onAddClose(e);
  }

  let _clearAll = () => {
    selectedAttribute = [];
    if (type != "006") {
      loadDataSet();
    }
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  function loadDataSet() {
    if (type == "001") {//udf value list
      needSearchBar = true;
      needPagination = true;

      _loadUserAttributeList();
    } else if (type == "002") {//User role set
      needSearchBar = false;
      needPagination = false;
      _loadUserRoleList();
    } else if (type == "003") {//Store Groups
      needSearchBar = true;
      needPagination = false;
      _loadStoreGroupList();
    } else if (type == "004") {//Stores
      needSearchBar = true;
      needPagination = false;
      _loadStoredList();
    } else if (type == "005") {//Task List
      needSearchBar = true;
      needPagination = true;
      _loadTaskList();
    } else if (type == "006") {//User List
      needSearchBar = true;
      needPagination = false;
      if (inputDatModel.user != "") {
        _loadUserList();
      } else {
        isMsgOpen = true;
        showMsg = languageModel.getText("EM00000317", "Search text box cannot be empty!");
        msgTitle = languageModel.getText("EM00000142", "Error");
      }
    }

    if (needSearchBar && needPagination) {
      hightClass = ".attributeListHeight-547";
    } else if (!needSearchBar && !needPagination) {
      hightClass = ".attributeListHeight-697";
    } else {
      hightClass = ".attributeListHeight-613";
    }
  }

  function _loadStoreGroupList() {
    inputDatModel.userAttributeList = [];
    userSearchModal.getStoreGroupList(
      (result) => {
        if (result != null) {
          result.forEach(function (item) {
            let itemExists = selectedAttribute.findIndex(x => x.value == item.code) > -1;
            if (!itemExists) {
              inputDatModel.userAttributeList.push({ value: item.code, text: item.name });
            }
          });
        } else {
          inputDatModel.userAttributeList = [];
        }
      },
      (error) => {
        isMsgOpen = true;
        showMsg = error.response[0].transStatus;
        msgTitle = this.getText(error.response[0].code);
      },
      {
        siteGroupName: inputDatModel.user,
        countryCode: country,
      }
    )
  }

  function _loadTaskList() {
    inputDatModel.userAttributeList = [];
    userSearchModal.getTaskMasterList(
      (result) => {
        if (result != null) {
          result.data.forEach(function (item) {
            let itemExists = selectedAttribute.findIndex(x => x.value == item.taskMstId) > -1;
            if (!itemExists) {
              inputDatModel.userAttributeList.push({ value: item.taskMstId, text: item.taskName });
            }
          });
          inputDatModel.pageIndex = result.pageIndex;
          inputDatModel.pageSize = result.pageSize;
          inputDatModel.totalCount = result.total;
        }
        else {
          inputDatModel.userAttributeList = [];
        }
      },
      (error) => {
        isMsgOpen = true;
        showMsg = error.response[0].transStatus;
        msgTitle = this.getText(error.response[0].code);
      },
      inputDatModel.user//TaskName
      , inputDatModel.pageIndex, inputDatModel.pageSize
    )
  }

  function _loadUserList() {
    inputDatModel.userAttributeList = [];
    userSearchModal.getUserBySupervisor(
      (result) => {
        if (result != null) {
          result.forEach(function (item) {
            let itemExists = selectedAttribute.findIndex(x => x.value == item.userID) > -1;
            if (!itemExists) {
              inputDatModel.userAttributeList.push({ value: item.userID, text: item.userName });
            }
          });
        } else {
          inputDatModel.userAttributeList = [];
        }
      },
      (error) => {
        isMsgOpen = true;
        showMsg = error.response[0].transStatus;
        msgTitle = this.getText(error.response[0].code);
      },
      inputDatModel.user, country

    )
  }

  function _loadStoredList() {
    inputDatModel.userAttributeList = [];
    userSearchModal.getStoreList(
      (result) => {
        if (result != null) {
          result.forEach(function (item) {
            let itemExists = selectedAttribute.findIndex(x => x.value == item.code) > -1;
            if (!itemExists) {
              inputDatModel.userAttributeList.push({ value: item.code, text: item.name });
            }
          });
        } else {
          inputDatModel.userAttributeList = [];
        }
      },
      (error) => {
        isMsgOpen = true;
        showMsg = error.response[0].transStatus;
        msgTitle = this.getText(error.response[0].code);
      },
      {
        CountryCode: country,
        SiteIdOrName: inputDatModel.user
      }
    )
  }

  function _loadUserRoleList() {
    inputDatModel.userAttributeList = [];
    userSearchModal.getUserRoleList(
      (result) => {
        if (result != null) {
          result.forEach(function (item) {
            let itemExists = selectedAttribute.findIndex(x => x.value == item.code) > -1;
            if (!itemExists) {
              inputDatModel.userAttributeList.push({ value: item.code, text: item.name });
            }
          });
        } else {
          inputDatModel.userAttributeList = [];
        }
      },
      (error) => {
        isMsgOpen = true;
        showMsg = error.response[0].transStatus;
        msgTitle = this.getText(error.response[0].code);
      },
      country
    )
  }

  function _loadUserAttributeList() {
    inputDatModel.userAttributeList = [];
    userSearchModal.getUserAttributeList(
      (result) => {
        inputDatModel.pageIndex = result.pageIndex;
        inputDatModel.pageSize = result.pageSize;
        inputDatModel.totalCount = result.total;
        result.data.forEach(function (item) {
          let itemExists = selectedAttribute.findIndex(x => x.value == item.udfValueId) > -1;
          if (!itemExists) {
            inputDatModel.userAttributeList.push({ value: item.udfValueId, text: item.udfValue, checked: false });
          }
        });
      },
      (error) => {
        isMsgOpen = true;
        showMsg = error.response[0].transStatus;
        msgTitle = this.getText(error.response[0].code);
      },
      inputDatModel.masterId, inputDatModel.pageIndex, inputDatModel.pageSize, inputDatModel.user
    )
  }

  let _search = () => {
    loadDataSet();
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDatModel.pageIndex = pageIndex;
    inputDatModel.pageSize = pageSize;
    loadDataSet();
  }

  let onPageChanged = (pageIndex) => {
    inputDatModel.pageIndex = pageIndex;
    loadDataSet();
  }

  function isChecked(value) {
    const ic = selectedAttribute.findIndex(x => x.value == value) > -1;
    return ic;
  }

  function getSelectedAttribute(detail, target) {
    if (target.checked) {
      selectedAttribute.push(detail);
      inputDatModel.userAttributeList = inputDatModel.userAttributeList.filter(x => x.value != detail.value);
    } else {
      selectedAttribute = selectedAttribute.filter(x => x.value != detail.value);
      inputDatModel.userAttributeList.push(detail);
    }
  }

  function removeSelectedAttribute(detail) {
    selectedAttribute = selectedAttribute.filter(x => x.value != detail.value);
    inputDatModel.userAttributeList.push(detail);
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.type) {
        type = vnode.attrs.type;
        if (type == '001') {
          if (vnode.attrs.masterId) {
            inputDatModel.masterId = vnode.attrs.masterId;
            loadDataSet();
          }
        }
        else if (type == '002' || type == '003' || type == '004' || type == '005') { //user roles,store groups,stores,task list
          if (vnode.attrs.country) {
            country = vnode.attrs.country;

          }
          else {
            country = loginModel.credentials.country;
          }
          loadDataSet();
        }
        else if (type == "006") { //user list
          if (vnode.attrs.country) {
            country = vnode.attrs.country;
          }
          else {
            country = loginModel.credentials.country;
          }
          needSearchBar = true;
          needPagination = false;
          hightClass = ".attributeListHeight-613";
        }
      }

      if (vnode.attrs.onAddClose) {
        onAddClose = vnode.attrs.onAddClose;
      }

      if (vnode.attrs.onSave) {
        onSave = vnode.attrs.onSave;
      }

      if (vnode.attrs.selectedAttribute) {
        selectedAttribute = vnode.attrs.selectedAttribute;
        selectedInputAttribute = vnode.attrs.selectedAttribute;
      }
    },
    view: (vnode) => {
      return [
        ('.card',
          m('.card-body',
            needSearchBar && m('.row.mb-4',
              m('.col-md-10',
                m('input.form-control.form-control-bg[type="text"][placeholder="' + this.getText("LT00000001", "Search") + '"]',
                  { onchange: _getName }
                ),
                type == '006' && m('span.invalid-feedback', { "style": "display:block !important" }, 'Display maximum 200 users only!')
              ),
              m('.col-md-2', m('button.btn.btn-danger', { onclick: _search }, this.getText("LT00000001", "Search")))
            ),
            // needSearchBar && m('hr.my-4'),
            m(".col-md-12",
              m(".card",
                m(".card-body",
                  m(".col-md-12",
                    selectedAttribute.length > 0 && m('ul.selected-ul-list',
                      selectedAttribute.map(gc =>
                        [
                          m('li.float-left.with-border',
                            m('button.btn.btn-sm.btn-primary.list-remove-btn', { onclick: () => { removeSelectedAttribute(gc) } }, 'X'),
                            m('span', gc.text))
                        ]),
                    ),
                  ),
                  m(".col-md-12",
                    m(".table-responsive" + hightClass + "",
                      m("table.table",
                        [
                          m("thead.thead-bggrey",
                            m("tr.align-middle", [
                              m("th", { "scope": "col", "style": "width:0px" }, this.getText("LT00000063", "Select")),
                              m("th", { "scope": "col" }, this.getText("LT00000014", "Data Value"))
                            ])
                          ),
                          m("tbody",
                            inputDatModel.userAttributeList.length == 0 &&
                            m("tr", { "class": "align-middle" },
                              m("td", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                            ),
                            inputDatModel.userAttributeList.map(gc => [
                              m("tr",
                                [
                                  m("td", m('div.form-check',
                                    m('input[class="form-check-input"][type="checkbox"]', {
                                      "id": gc.value,
                                      "value": gc.text,
                                      checked: isChecked(gc.value),
                                      onclick: (e) => {
                                        getSelectedAttribute(gc, e.target)
                                      }
                                    }
                                    )
                                  )),
                                  m("td", gc.text)
                                ])
                            ]),
                          )
                        ])
                    ),
                    (needPagination && inputDatModel.totalCount > 0) && m(paginationComponent, { currentPage: inputDatModel.pageIndex, pageSize: inputDatModel.pageSize, totalItems: inputDatModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                  )
                ),
                m('.card-footer',
                  m('.col-md-12 .gap-2 .d-flex .justify-content-center',
                    m("button.btn.btn-danger[type='button']", { onclick: _clearAll },
                      this.getText("LT00000073", "Clear All")
                    ),
                    m("button.btn.btn-white[type='button']", { onclick: _cancel },
                      this.getText("LT00000021", "Close")
                    ),
                    m("button.btn.btn-primary[type='button']", { onclick: _save },
                      this.getText("LT00000022", "Save")
                    )
                  ))
              )
            )
          )
        ),
        m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed }),
        this.getBaseViews()
      ];
    }
  }
}
